import { RegisterFileUploadType, UserData, StepRegisterInputData, ResumeInputData } from './types';
import { action, PayloadAction } from 'typesafe-actions';
import RegisterPharmacyActionTypes, { RegisterInputData } from './types';
import { FileUploadType } from '@shared/components';
import { ActionServicePayload, ActionMetaService, ActionServiceEmpty } from 'ff-shared-components-core';
import { EnrollmentTypes } from '@api/ff-shared-services-api';

/**
 * Input data flow actions
 */
export const saveTransferInputData = (
	registerInputData: RegisterInputData,
	stepIndex: number
): PayloadAction<string, StepRegisterInputData> =>
	action(RegisterPharmacyActionTypes.SAVE_REGISTER_INPUT_DATA, { registerInputData, stepIndex });

export const saveUserData = (userData: UserData): PayloadAction<string, UserData> =>
	action(RegisterPharmacyActionTypes.SAVE_USER_DATA, userData);

export const updateUserData = (userData: UserData): PayloadAction<string, UserData> =>
	action(RegisterPharmacyActionTypes.UPDATE_USER_DATA, userData);

export const removeUserData = (userId: number): PayloadAction<string, number> =>
	action(RegisterPharmacyActionTypes.REMOVE_USER_DATA, userId);

/**
 * Init register
 */
export const fetchPublicRegisterInitRequest = (metaData?: ActionMetaService): ActionServiceEmpty =>
	action(RegisterPharmacyActionTypes.FETCH_PUBLIC_REGISTER_INIT_REQUEST, undefined, metaData);

export const fetchConfigurationsSuccess = (
	data: EnrollmentTypes.EnrollmentConfiguration
): PayloadAction<string, EnrollmentTypes.EnrollmentConfiguration> =>
	action(RegisterPharmacyActionTypes.FETCH_CONFIGURATIONS_SUCCESS, data);

export const fetchAddRegisterDataSuccess = (externalId: string): PayloadAction<string, string> =>
	action(RegisterPharmacyActionTypes.FETCH_ADD_REGISTER_DATA_SUCCESS, externalId);

/**
 * Update register data
 */
export const fetchUpdateRegisterDataRequest = (
	registerData: StepRegisterInputData,
	metaData?: ActionMetaService
): ActionServicePayload<StepRegisterInputData> =>
	action(RegisterPharmacyActionTypes.FETCH_UPDATE_REGISTER_DATA_REQUEST, registerData, metaData);

export const fetchUpdateRegisterDataSuccess = (
	registerData: EnrollmentTypes.Request
): PayloadAction<string, EnrollmentTypes.Request> =>
	action(RegisterPharmacyActionTypes.FETCH_UPDATE_REGISTER_DATA_SUCCESS, registerData);

/**
 * Update register data
 */
export const fetchSendForApprovalRequest = (metaData?: ActionMetaService): ActionServiceEmpty =>
	action(RegisterPharmacyActionTypes.FETCH_SEND_FOR_APPROVAL_REQUEST, undefined, metaData);

export const fetchSendForApprovalSuccess = (
	approvalData: EnrollmentTypes.Request
): PayloadAction<string, EnrollmentTypes.Request> =>
	action(RegisterPharmacyActionTypes.FETCH_SEND_FOR_APPROVAL_SUCCESS, approvalData);

/**
 * File upload actions
 */
export const fetchUploadFileExecutionRequest = (
	fileData: FileUploadType,
	metaData?: ActionMetaService
): ActionServicePayload<FileUploadType> =>
	action(RegisterPharmacyActionTypes.FETCH_UPLOAD_FILE_EXECUTION_REQUEST, fileData, metaData);

export const fetchUploadFileExecutionSuccess = (
	data: RegisterFileUploadType
): PayloadAction<string, RegisterFileUploadType> =>
	action(RegisterPharmacyActionTypes.FETCH_UPLOAD_FILE_EXECUTION_SUCCESS, data);

export const fetchUploadFileExecutionError = (error): PayloadAction<string, any> =>
	action(RegisterPharmacyActionTypes.FETCH_UPLOAD_FILE_EXECUTION_ERROR, error);

export const removeUploadFileExecution = (currentStep: number): PayloadAction<string, number> =>
	action(RegisterPharmacyActionTypes.REMOVE_UPLOAD_FILE_EXECUTION, currentStep);

export const fetchDownloadContractFileRequest = (metaData?: ActionMetaService): ActionServiceEmpty =>
	action(RegisterPharmacyActionTypes.FETCH_DOWNLOAD_CONTRACT_FILE_REQUEST, undefined, metaData);

export const fetchDownloadRegisterDocumentByIdRequest = (
	fileId: string,
	metaData?: ActionMetaService
): ActionServicePayload<string> =>
	action(RegisterPharmacyActionTypes.FETCH_DOWNLOAD_DOCUMENT_REQUEST, fileId, metaData);

// RESUME REGISTER
export const resumeRegisterRequest = (data: ResumeInputData, metaData?: ActionMetaService): ActionServiceEmpty =>
	action(RegisterPharmacyActionTypes.RESUME_REGISTER_REQUEST, data, metaData);

//	SAVE_REGISTER_ON_CANCEL
export const saveRegisterOnCancel = (metaData?: ActionMetaService): ActionServiceEmpty =>
	action(RegisterPharmacyActionTypes.SAVE_REGISTER_ON_CANCEL, undefined, metaData);
